import { Box, Theme, useMediaQuery } from "@mui/material";
import React from "react";
import WalletManagerLogo from "../WalletManagerLogo";
import ToggleButton from "./components/ToggleButton";
import {
  LogoContainer,
  SideMenuContainer,
  SideMenuContent,
  SideMenuDivider,
  SideMenuSpaceHolder,
} from "./sx";

interface IProps {
  children: React.ReactNode;
  isDeskTopMenuCollapse: boolean;
  isShowSideMenuInMobileView: boolean;
  onCollapseClick: () => void;
}

const SideMenu = ({
  children,
  isDeskTopMenuCollapse,
  isShowSideMenuInMobileView,
  onCollapseClick,
}: IProps) => {
  const isMobileView = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("sm"),
  );
  const isMobileMenuCollapse = isMobileView && !isShowSideMenuInMobileView;

  return (
    <Box>
      {!isMobileView && (
        <SideMenuSpaceHolder isCollapse={isDeskTopMenuCollapse} />
      )}
      <SideMenuContainer
        isDeskTopMenuCollapse={!isMobileView && isDeskTopMenuCollapse}
        isMobileMenuCollapse={isMobileMenuCollapse}
      >
        {!isMobileView && (
          <ToggleButton
            onCollapseClick={onCollapseClick}
            isCollapse={isDeskTopMenuCollapse}
          />
        )}
        <SideMenuContent
          isCollapse={isDeskTopMenuCollapse || isMobileMenuCollapse}
        >
          <LogoContainer>
            <WalletManagerLogo />
          </LogoContainer>
          <SideMenuDivider />
          {children}
        </SideMenuContent>
      </SideMenuContainer>
    </Box>
  );
};

export default SideMenu;
